import React from "react";

export function BrandMark({ className = "h-7 w-7", tone = "dark" }: { className?: string; tone?: "dark" | "light" }) {
  const corner = tone === "dark" ? "#FFC21A" : "#D99A00";
  const dot = tone === "dark" ? "#FFFFFF" : "#161C27";
  return (
    <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
      <path d="M3 11V3h8M21 3h8v8M29 21v8h-8M11 29H3v-8" stroke={corner} strokeWidth="2.5" />
      <circle cx="16" cy="16" r="4.5" fill={dot} />
    </svg>
  );
}
